import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-datetest',
  templateUrl: './datetest.component.html',
  styleUrls: ['./datetest.component.scss']
})
export class DatetestComponent implements OnInit {

  constructor() { }

  ngOnInit(): void  {
  }

}
